import React from 'react';
import { useSelector } from 'react-redux';
import Accordion from 'components/shared/generic/accordion/presentational/Accordion';
import { getTheme } from '../../../../../selectors/darkMode';
import clsx from 'clsx';
import { ZendeskArticle } from 'lib/type';

interface ZendeskFAQsProps {
    faqs: ZendeskArticle[] | undefined;
}

const ZendeskFAQs = ({ faqs }: ZendeskFAQsProps) => {
    const isDarkModeEnabled = useSelector(getTheme);

    return (
        <div
            className={clsx('zendesk-faqs', {
                'dark-mode': isDarkModeEnabled,
            })}
        >
            {faqs?.map(({ title, body }, index) => (
                <Accordion key={index} title={title} tracking>
                    {<div dangerouslySetInnerHTML={{ __html: body }}></div>}
                </Accordion>
            ))}
        </div>
    );
};

export default ZendeskFAQs;
